import { motion } from "framer-motion";

/**
 * Masked line reveal — used for the hero on-load moment.
 * `text` can be a string (rendered as-is) or JSX (must be inline).
 * Wrap each visual line in its own <RevealLine>.
 */
export default function RevealLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`mask-line ${className}`}>
      <motion.span
        className="inline-block will-change-transform"
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1.15, ease: [0.16, 1, 0.3, 1], delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}
